import { BsBoxes } from "react-icons/bs";
import { CiBadgeDollar } from "react-icons/ci";
import { FaAd, FaRegChartBar } from "react-icons/fa";
import { IoBriefcaseOutline } from "react-icons/io5";
import { GoQuestion } from "react-icons/go";
import { GrCompliance } from "react-icons/gr";
import { MdOutlineReviews, MdOutlineShoppingBag } from "react-icons/md";
import { RxDashboard } from "react-icons/rx";
import { SlSettings } from "react-icons/sl";
import { TbBuildingWarehouse } from "react-icons/tb";

export default [
    {
        id: "WholesalerDashboard",
        title: "Dashboard",
        icon: <RxDashboard size={20} />,
        navLink: "/dashboard",
    },
    {
        id: "Products",
        title: "Products",
        icon: <BsBoxes size={20} />,
        navLink: "/products",
        children: [
            {
                id: "ManageProducts",
                title: "Manage Products",
                navLink: "/products/manage",
            },
            {
                id: "AddProduct",
                title: "Add Product",
                navLink: "/products/add",
            },
            {
                id: "CategoryManagement",
                title: "Category Management",
                navLink: "/products/category",
            },
            {
                id: "BrandManagement",
                title: "Brand Management",
                navLink: "/products/brand",
            }
        ]
    },
    {
        id: "Orders",
        title: "Orders",
        icon: <MdOutlineShoppingBag size={20} />,
        navLink: "/orders",
        children: [
            {
                id: "ManageOrders",
                title: "Manage Orders",
                navLink: "/orders/manage",
            },
            {
                id: "OrderFulfillment",
                title: "Order Fulfillment",
                navLink: "/orders/fulfillment",
            },
            {
                id: "ReturnsAndRefunds",
                title: "Returns and Refunds",
                navLink: "/orders/returns-and-refunds",
            },
            {
                id: "OrderAnalytics",
                title: "Order Analytics",
                navLink: "/orders/order-analytics",
            },
        ]
    },
    {
        id: "FBM",
        title: "FBM",
        icon: <TbBuildingWarehouse size={20} />,
        navLink: "/fbmregister",
    },
    {
        id: "CustomerEngage",
        title: "Customer Engage",
        icon: <MdOutlineReviews size={20} />,
        navLink: "/customer-engage",
        children: [
            {
                id: 'CRM',
                title: 'CRM',
                navLink: '/customer-engage/customer-relationship-management'
            },
            {
                id: "Reviews",
                title: "Reviews",
                navLink: "/customer-engage/reviews",
            },
            {
                id: "VipCustomers",
                title: "Vip Customers",
                navLink: "/customer-engage/vip-customers",
            },
            {
                id: "PurchaseHistory",
                title: "Purchase History",
                navLink: "/customer-engage/purchase-history",
            },
        ]
    },
    {
        id: "MarketingOptions",
        title: "Marketing Options",
        icon: <CiBadgeDollar size={20} />,
        navLink: "/marketing-options",
        children: [
            {
                id: "Campaigns",
                title: "Campaigns",
                navLink: "/marketing-options/campaigns",
            },
            {
                id: "Coupons",
                title: "Coupons",
                navLink: "/marketing-options/coupons",
            },
            {
                id: "Vouchers",
                title: "Vouchers",
                navLink: "/marketing-options/vouchers",
            },
        ]
    },
    {
        id: "Advertisement",
        title: "Advertisement",
        icon: <FaAd size={20} />,
        navLink: "/advertisement",
        children: [
            {
                id: "Overview",
                title: "Overview",
                navLink: "/advertisement/overview",
            },
            {
                id: "Creation",
                title: "Creation",
                navLink: "/advertisement/creation",
            },
            {
                id: "Management",
                title: "Management",
                navLink: "/advertisement/management",
            },
            {
                id: "AdPerformance",
                title: "Ad Performance",
                navLink: "/advertisement/ad-performance",
            },
        ]
    },
    {
        id: "Finance",
        title: "Finance",
        icon: <IoBriefcaseOutline size={20} />,
        navLink: "/finance",
        children: [
            {
                id: "Overview",
                title: "Overview",
                navLink: "/finance/overview",
            },
            {
                id: "TransactionHistory",
                title: "Transaction History",
                navLink: "/finance/transaction-history",
            },
            {
                id: "PaymentInfo",
                title: "Payment Info",
                navLink: "/finance/payment-info",
            },
            {
                id: "FeeBreakdown",
                title: "Fee Breakdown",
                navLink: "/finance/fee-breakdown",
            },
            {
                id: "SellerFinancing",
                title: "Seller Financing",
                navLink: "/finance/seller-financing",
            },
        ]
    },
    {
        id: "ReportsAnalytics",
        title: "Reports & Analytics",
        icon: <FaRegChartBar size={20} />,
        navLink: "/analytics",
    },
    {
        id: "Compliance",
        title: "Compliance",
        icon: <GrCompliance size={20} />,
        navLink: "/compliance",
        children: [
            {
                id: "Policies",
                title: "Policies",
                navLink: "/compliance/policies",
            },
            {
                id: "ProductAdvisory",
                title: "Product Advisory",
                navLink: "/compliance/productadvisory",
            },
        ]
    },
    {
        id: "OtherResources",
        title: "Other Resources",
        icon: <GoQuestion size={20} />,
        navLink: "/other-resources",
        children: [
            {
                id: "DocumentTemplate",
                title: "Document Template",
                navLink: "/other-resources/document-template",
            },
            {
                id: "Services",
                title: "Services",
                navLink: "/other-resources/services",
            },
            {
                id: "PackagingMaterial",
                title: "Packaging Material",
                navLink: "/other-resources/packaging-material",
            },
        ]
    },
    {
        id: "Settings",
        title: "Settings",
        icon: <SlSettings size={20} />,
        navLink: "/settings",
        children: [
            {
                id: "Profile",
                title: "Profile",
                navLink: "/settings/profile",
            },
            {
                id: "Security",
                title: "Security",
                navLink: "/settings/security",
            },
            {
                id: "Commission",
                title: "Commission",
                navLink: "/settings/commission",
            },
            {
                id: "Notification",
                title: "Notification",
                navLink: "/settings/notification",
            },
            {
                id: "User",
                title: "User",
                navLink: "/settings/user",
            },
            {
                id: "ChatSetting",
                title: "Chat Setting",
                navLink: "/settings/chat-setting",
            },
            {
                id: "StoreSetting",
                title: "Store Setting",
                navLink: "/settings/store-setting",
            },
        ]
    },
];